import { render } from "./MarketplaceAppList.vue?vue&type=template&id=6040d9a4&scoped=true"
import script from "./MarketplaceAppList.vue?vue&type=script&lang=js"
export * from "./MarketplaceAppList.vue?vue&type=script&lang=js"

import "./MarketplaceAppList.vue?vue&type=style&index=0&id=6040d9a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6040d9a4"]])

export default __exports__